import React, { useState } from "react";
import { FaArrowLeft, FaWhatsapp } from "react-icons/fa";
import { IoSend } from "react-icons/io5";
import "./SignUp.css";

function SignUp({ onBack }) {
  const [name, setName] = useState("");

  const handleWhatsApp = () => {
    const nameClause = name.trim() ? `, sou ${name}` : "";
    const message = `Olá Bravas${nameClause}, estou interessado em adquirir o plano Cloud.`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://api.whatsapp.com/send?phone=551129247613&text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="signup-container paper-background">
      <div className="signup-header">
        <button className="signup-back-icon" onClick={onBack}>
          <FaArrowLeft size={20} />
        </button>
        <h2>Cadastre-se para obter acesso</h2>
      </div>
      <p>Entre em contato com a Bravas e contrate um plano Cloud!</p>

      <div className="signup-input-container">
        <FaWhatsapp className="signup-whatsapp-icon" />
        <input
          className="signup-input"
          placeholder="Digite seu nome"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <button className="signup-send-button" onClick={handleWhatsApp}>
          <IoSend />
        </button>
      </div>
    </div>
  );
}

export default SignUp;
